import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgPlaylists = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.625 11.9996H12.625C12.7908 11.9996 12.9497 11.9337 13.0669 11.8165C13.1842 11.6993 13.25 11.5403 13.25 11.3746V10.1246C13.25 9.95883 13.1842 9.79986 13.0669 9.68265C12.9497 9.56544 12.7908 9.49959 12.625 9.49959H2.625C2.45924 9.49959 2.30027 9.56544 2.18306 9.68265C2.06585 9.79986 2 9.95883 2 10.1246V11.3746C2 11.5403 2.06585 11.6993 2.18306 11.8165C2.30027 11.9337 2.45924 11.9996 2.625 11.9996ZM2.625 6.99959H12.625C12.7908 6.99959 12.9497 6.93374 13.0669 6.81653C13.1842 6.69932 13.25 6.54035 13.25 6.37459V5.12459C13.25 4.95883 13.1842 4.79986 13.0669 4.68265C12.9497 4.56544 12.7908 4.49959 12.625 4.49959H2.625C2.45924 4.49959 2.30027 4.56544 2.18306 4.68265C2.06585 4.79986 2 4.95883 2 5.12459V6.37459C2 6.54035 2.06585 6.69932 2.18306 6.81653C2.30027 6.93374 2.45924 6.99959 2.625 6.99959ZM7.625 14.4996H2.625C2.45924 14.4996 2.30027 14.5654 2.18306 14.6826C2.06585 14.7999 2 14.9588 2 15.1246V16.3746C2 16.5403 2.06585 16.6993 2.18306 16.8165C2.30027 16.9337 2.45924 16.9996 2.625 16.9996H7.625C7.79076 16.9996 7.94973 16.9337 8.06694 16.8165C8.18415 16.6993 8.25 16.5403 8.25 16.3746V15.1246C8.25 14.9588 8.18415 14.7999 8.06694 14.6826C7.94973 14.5654 7.79076 14.4996 7.625 14.4996ZM20.3961 2.05154L16.6254 3.16522C16.3717 3.24489 16.1501 3.40337 15.9927 3.61763C15.8353 3.83188 15.7502 4.09075 15.75 4.35662V16.0621C15.1464 15.8557 14.5129 15.7501 13.875 15.7496C11.4586 15.7496 9.5 17.1488 9.5 18.8746C9.5 20.6004 11.4586 21.9996 13.875 21.9996C16.2914 21.9996 18.25 20.6004 18.25 18.8746V7.7867L21.1016 6.95115C21.3609 6.87516 21.5885 6.7172 21.7505 6.50093C21.9125 6.28467 22 6.02174 22 5.75154V3.24959C21.9999 3.05526 21.9544 2.86363 21.8673 2.68993C21.7802 2.51623 21.6537 2.36523 21.498 2.24894C21.3424 2.13264 21.1617 2.05425 20.9704 2.01998C20.7791 1.98572 20.5825 1.99652 20.3961 2.05154Z", fill: props.fill }));
});
export default SvgPlaylists;
